const Primary = {
  Primary: {
    _000: '#EFF6FF',
    _100: '#DCEDFE',
    _200: '#BADEFD',
    _300: '#91C7FD',
    _400: '#66A8FA',
    _500: '#3B89F6',
    _600: '#2D6BE6',
    _700: '#2552D0',
    _800: '#2343AA',
    _900: '#1C356A',
  },
  PrimaryGray: {
    _000: '#F8FAFC',
    _100: '#F1F5F9',
    _200: '#E2E8F0',
    _300: '#CBD5E1',
    _400: '#94A3B8',
    _500: '#64748B',
    _600: '#475569',
    _700: '#334155',
    _800: '#1E293B',
    _900: '#0F172A',
  },
};

export default Primary;
